var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 480h-96.17v-48c0-8.844-7.156-16-16-16s-16 7.156-16 16V480H208c-8.844 0-15.99 7.156-15.99 16S199.2 512 208 512l223.1-.1667c8.844 0 15.99-7.156 15.99-16S440.8 480 432 480zM639.1 309.5l-44.26-256C589.5 22.62 561.8 0 529.3 0H110.7C78.22 0 50.52 22.62 45.18 53.48l-44.26 256C-5.824 348.5 25.38 384 66.41 384h507.2C614.6 384 645.8 348.5 639.1 309.5zM255.1 32h130.3l13.18 144.1H241.7L255.1 32zM193.4 352H66.41c-10.63 0-20.51-4.48-27.08-12.29c-3.457-4.107-8.949-12.79-6.875-24.78l18.32-105.1H206.6L193.4 352zM209.6 176.1H56.31l20.41-118C79.41 43.33 93.69 32 110.7 32h112.3L209.6 176.1zM225.6 352l13.21-143h162.7L414.5 352H225.6zM417.5 32h111.8c16.98 0 31.26 11.33 33.96 26.93l20.41 118h-152.1L417.5 32zM600.7 339.7C594.1 347.5 584.2 352 573.6 352H446.6l-13-143h155.6l18.32 105.1C609.6 326.9 604.1 335.6 600.7 339.7z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanel);
export default __webpack_public_path__ + "static/media/solar-panel.076c7a4fcf4170e613d3dc31cdfa053d.svg";
export { ForwardRef as ReactComponent };